import { Navigate } from 'react-router-dom'
import ApprovalPage from 'features/private-views/approval'
import PurchaseCommodity from 'features/private-views/purchase-commodity'
import SellCommodityView from 'features/private-views/sell-commodity'
import SuccessTrx from 'features/private-views/sell-commodity/SuccessTrx'
import SettingView from 'features/private-views/settings'
import TalanginInvoice from 'features/private-views/talangin-invoice'
import ConfirmRollover from 'features/private-views/talangin-invoice/rollover/ConfirmRollover'
import Rollover from 'features/private-views/talangin-invoice/rollover/Rollover'
import Withdraw from 'features/private-views/withdraw'

import Transactions from 'private-views/transactions'
import AddComodity from 'private-views/transactions/AddComodity'
import SuccesTransaction from 'private-views/transactions/SuccesTransaction'
import ConfirmPayment from 'private-views/transactions/confirmPayment'
import Payment from 'private-views/transactions/payment'
import TalanginConfirm from 'private-views/transactions/talanginConfirm'

import ApprovalTable from 'features/private-views/approval/ApprovalTable'
import TableRequestSell from 'features/private-views/approval/TableRequestSell'
import TableRequestWithdrawal from 'features/private-views/approval/TableRequestWithdrawal'
import CashFlow from 'features/private-views/cash-flow'
import CashFlowNotes from 'features/private-views/cash-flow-notes'
import FormCashFlow from 'features/private-views/cash-flow/FormCashFlow'
import CommodityRepo from 'features/private-views/commodity-repo'
import ListRepo from 'features/private-views/commodity-repo/ListRepo'
import SubmissionRepo from 'features/private-views/commodity-repo/SubmissionRepo'
import FarmersWeb from 'features/private-views/farmers-web'
import CheckFarmers from 'features/private-views/farmers-web/check-farmers'
import DetailFarmers from 'features/private-views/farmers-web/detail'
import FarmersTable from 'features/private-views/farmers-web/farmers-list'
import FarmersPendingList from 'features/private-views/farmers-web/farmers-pending-list'
import FormRegis from 'features/private-views/farmers-web/forms'
import SharedFarmers from 'features/private-views/farmers-web/shared-farmers'
import PayableNotes from 'features/private-views/payable-notes'
import ApprovalList from 'features/private-views/payable-notes/ApprovalList'
import FormPayableNotes from 'features/private-views/payable-notes/FormPayableNotes'
import ReceivableNotes from 'features/private-views/receivable-notes'
import Tnc from 'features/private-views/tnc'
import TopupOnePayment from 'features/private-views/topup/index2'
import { ManageStock } from 'features/public-views/manageStock'
import Spatial from 'features/public-views/spatial'
import ConfirmCashPayment from 'private-views/transactions/confirmCashPayment'
// VESSELS
import Vessels from 'features/private-views/vessels'
import DetailVessels from 'features/private-views/vessels/detail'
import FormAddVessel from 'features/private-views/vessels/forms'
import VessselsTable from 'features/private-views/vessels/list-vessels'
// CATCHES
import Catches from 'features/private-views/catches'
import DetailCatches from 'features/private-views/catches/detail'
import CatchesTable from 'features/private-views/catches/list-catches'
// GEARS
import Gears from 'features/private-views/gears'
import GearsTable from 'features/private-views/gears/list-gears'
// PORTS
import Ports from 'features/private-views/ports'
import PortsTable from 'features/private-views/ports/list-ports'
// COMPANIES
import Companies from 'features/private-views/companies'
import FormAddCompanies from 'features/private-views/companies/forms'
import CompaniesTable from 'features/private-views/companies/list-companies'
// FISHERIES
import Fisheries from 'features/private-views/fisheries'
import FormAddFisheries from 'features/private-views/fisheries/forms'
import FisheriesTable from 'features/private-views/fisheries/list-fisheries'
// WHISTLE BLOWING
import WhistleBlowings from 'features/private-views/whistle-blowings'
import WhistleBlowingsTable from 'features/private-views/whistle-blowings/list-whistle-blowings'
// APPROVAL FARMERS
import ApprovalFarmers from 'features/private-views/farmers-web/approval'
// ADDRESS BOOK
import ListAddressBook from 'features/private-views/address-book/ListAddressBook'
// CONFIGURATIONS
import Configurations from 'features/private-views/configurations'
import ListConfigurations from 'features/private-views/configurations/list-configurations'
import AddConfiguration from 'features/private-views/configurations/list-configurations/AddConfiguration'

import ReportPnbp from 'features/private-views/report-pnbp'
import ListReportPnbp from 'features/private-views/report-pnbp/list-report-pnbp'
import DetailReportPnbp from 'features/private-views/report-pnbp/list-report-pnbp/DetailReportPnbp'

import AnnualCapacity from 'features/private-views/annual-capacity'
import Attendance from 'features/private-views/attendance'
import AttendanceIndividualManagement from 'features/private-views/attendance-report/attendance-individual-management'
import IndividualReport from 'features/private-views/attendance-report/individual-report'
import TodayReport from 'features/private-views/attendance-report/today-report'
import AttendanceSummary from 'features/private-views/attendance-summary'
import Budget from 'features/private-views/balance/budget'
import DetailCashFlowById from 'features/private-views/cash-flow/DetailCashFlowById'
import HistoryCashFlow from 'features/private-views/cash-flow/HistoryCashFlow'
import CenterAttendance from 'features/private-views/center-attendance'
import DetailTransaction from 'features/private-views/dashboard/DetailTransaction'
import GroupsList from 'features/private-views/farmers-web/groups-list'
import StaffList from 'features/private-views/farmers-web/staffList'
import ListFindoraDashboard from 'features/private-views/findora-dashboard'
import ListFindoraLogs from 'features/private-views/findora-logs'
import InventoriIntelligent from 'features/private-views/inventori-intelligent'
import DetailInventoriIntelligent from 'features/private-views/inventori-intelligent/detail'
import Learning from 'features/private-views/learning'
import LearningReport from 'features/private-views/learning-report'
import ListTransactions from 'features/private-views/list-transanctions'
import TransactionSummary from 'features/private-views/transaction-summary'
import MutationReport from 'features/private-views/mutation-report'
import DetailMutationReport from 'features/private-views/mutation-report/detail'
import NotifInboxTable from 'features/private-views/notification-inbox'
import OrderAdjustment from 'features/private-views/order-adjustment'
// MASTER ITEMS & MAP SCHEMA

import ListEmployeePayments from 'features/private-views/employee-payments'
import AutoCalculation from 'features/private-views/employee-payments/AutoCalculation'
import PaymentSummary from 'features/private-views/employee-payments/PaymentSummary'
import WageSalary from 'features/private-views/wage-salary'
import WageSalaryCreate from 'features/private-views/wage-salary/WageSalaryCreate'
import WageSalaryDetail from 'features/private-views/wage-salary/WageSalaryDetail'
import FormEventParticipant from 'features/private-views/event-participant/FormEventParticipant'
import ListEventParticipant from 'features/private-views/event-participant/ListEventParticipant'
import FormEventPartner from 'features/private-views/event-partner/FormEventPartner'
import ListEventReport from 'features/private-views/event-partner/ListEventPartner'
import FormEvent from 'features/private-views/event/FormEvent'
import ListEventApproval from 'features/private-views/event/event-approval/ListEventApproval'
import EventCertificateList from 'features/private-views/event/event-certificate/EventCertificate'
import EventCertificateDetail from 'features/private-views/event/event-certificate/EventCertificateDetail'
import ListEvent from 'features/private-views/event/event-timeline/ListEvent'
import FindoraItems from 'features/private-views/findora-items'
import Homepage from 'features/private-views/homepage'
import ListMapSchema from 'features/private-views/map-schema'
import ListMasterItems from 'features/private-views/master-items'
import DetailPayable from 'features/private-views/payable-notes/DetailPayable'
import PaymentHistory from 'features/private-views/payable-notes/PaymentHistory'
import IndexTabARAP from 'features/private-views/payable-notes/indexTab'
import IndexProcess from 'features/private-views/process/IndexProcess'
import ProcessPage from 'features/private-views/process/form-process/FormProcess'
import ListProcess from 'features/private-views/process/list-process/ListProcess'
import QRList from 'features/private-views/process/qr-list/QRList'
import JoinSession from 'features/private-views/process/session/JoinSession'
import Session from 'features/private-views/process/session/Session'
import ListProductMapping from 'features/private-views/product-mapping'
import ListProductMappingSchema from 'features/private-views/product-mapping-schema'
import ProjectDashboard from 'features/private-views/project-dashboard'
import ListProjectsMenu from 'features/private-views/projects-menu'
import DetailProject from 'features/private-views/projects-menu/DetailProject'
import FormAddEditProject from 'features/private-views/projects-menu/FormAddEditProject'
import DetailReceivable from 'features/private-views/receivable-notes/DetailReceivable'
import ReportFulfilment from 'features/private-views/report-fulfilment'
import DetailReportFulfilment from 'features/private-views/report-fulfilment/detail'
import ReportProcess from 'features/private-views/report-process'
import DetailProcess from 'features/private-views/report-process/DetailProcess'
import CompanySetting from 'features/private-views/settings/CompanySetting'
import PasswordSetting from 'features/private-views/settings/PasswordSetting'
import PinSetting from 'features/private-views/settings/PinSetting'
import TeamSetting from 'features/private-views/settings/TeamSetting'
import ScannerSetting from 'features/private-views/settings/ScannerSetting'
import PrinterSetting from 'features/private-views/settings/PrinterSetting'
import AutoNumberSetting from 'features/private-views/settings/AutoNumberSetting'
import PriceTable from 'features/private-views/settings/PriceTable'
import ProductionUnit from 'features/private-views/settings/production-unit'
import DetailProductionUnit from 'features/private-views/settings/production-unit/DetailProductionUnit'
import FormProductionUnit from 'features/private-views/settings/production-unit/FormProductionUnit'
import SyncDataList from 'features/private-views/sync-data'
import PinConfirm from 'features/private-views/talangin-invoice/PinConfirm'
import DetailTalanginInvoice from 'features/private-views/talangin-invoice/detail-talangin-invoice'
import TransferInventory from 'features/private-views/transfer-inventory'
import DetailTransferInventory from 'features/private-views/transfer-inventory/DetailTransferInventory'
import FormTransferInventory from 'features/private-views/transfer-inventory/FormTfInventory'
import Warehouse from 'features/private-views/warehouse'
import FormWarehouse from 'features/private-views/warehouse/FormWarehouse'
import DetailWarehouse from 'features/private-views/warehouse/detail'
import ListWorkplace from 'features/private-views/workplace/ListWorkplace'
import { Insight, Logs } from 'features/public-views/ap2hi'
import InventoryMembers from 'features/public-views/inventoryMembers/InventoryMembers'
import { DetailInventoriesPacking } from 'features/public-views/manageStock/DetailInventoriesPacking'
import CheckPinTrx from 'private-views/transactions/CheckPinTrx'
import AgencyViewPayment from 'private-views/transactions/confirmPayment/AgencyViewPayment'
import QRPrinting from 'features/private-views/qr-printing'
import TransactionQRPrint from 'features/private-views/qr-printing/TransactionQRPrint'
import {
  // URL_HOMEPAGE,
  ARUS_KAS,
  ARUS_KAS_FORM,
  DETAIL_CASHFLOW,
  HISTORY_ARUS_KAS,
  URL_ADDRESS_BOOK,
  URL_AGENT_APPROVAL,
  URL_ANNUAL_CAPACITY,
  URL_AP2HI_INSIGHT,
  URL_AP2HI_LOG,
  URL_APPROVAL_BUY,
  URL_APPROVAL_SELL,
  URL_APPROVAL_WITHDRAWAL,
  URL_ARUS_KAS,
  URL_ATTENDANCE,
  URL_ATTENDANCE_INDIVIDUAL,
  URL_ATTENDANCE_REPORT,
  URL_ATTENDANCE_REPORT_MEMBER,
  URL_ATTENDANCE_TODAY,
  URL_BALANCE,
  URL_CATCHES,
  URL_CATCHES_DETAIL,
  URL_CENTER_ATTENDANCE,
  URL_CHECK_FARMERS,
  URL_COMPANIES,
  URL_COMPANIES_ADD,
  URL_CONFIGURATIONS,
  URL_CONFIGURATIONS_ADD,
  URL_CONFIRM_PIN_TALANGIN,
  URL_CONFIRM_PIN_TRANSAKSI,
  URL_DASHBOARD_TRACEABILITY,
  URL_DASHBOARD_TRACEABILITY_DETAIL,
  URL_DETAIL_INVENTORI_INTELLIGENCE,
  URL_DETAIL_INVENTORY,
  URL_DETAIL_PIUTANG,
  URL_DETAIL_PROCESS,
  URL_DETAIL_PRODUCTION_UNIT,
  URL_DETAIL_TAGIHAN_TALANGIN,
  URL_DETAIL_TRANSACTION_ID,
  URL_DETAIL_UTANG,
  URL_DETAIL_WAREHOUSE,
  URL_EMPLOYEE_PAYMENTS,
  URL_WAGE_SALARY,
  URL_WAGE_SALARY_CREATE,
  URL_WAGE_SALARY_DETAIL,
  URL_EMPLOYEE_PAYMENTS_AUTO_CALCULATION,
  URL_EMPLOYEE_PAYMENTS_SUMMARY,
  URL_EVENT,
  URL_EVENT_APPROVAL,
  URL_EVENT_CERTIFICATE,
  URL_EVENT_CERTIFICATE_DETAIL,
  URL_EVENT_FORM,
  URL_EVENT_PARTICIPANT,
  URL_EVENT_PARTICIPANT_FORM,
  URL_EVENT_PARTNER,
  URL_EVENT_PARTNER_FORM,
  URL_FARMERS,
  URL_FARMERS_DETAIL,
  URL_FARMERS_GROUPS,
  URL_FARMERS_PENDING,
  URL_FARMERS_REGIST,
  URL_FARMERS_SHARED,
  URL_FARMERS_SUBGROUP,
  URL_FINDORA_DASHBOARD,
  URL_FINDORA_ITEMS,
  URL_FINDORA_LOGS,
  URL_FINDORA_PRODUCT_MAPPING,
  URL_FINDORA_PRODUCT_MAPPING_SCHEMA,
  URL_FINDORA_SYNC_DATA,
  URL_FISHERIES,
  URL_FISHERIES_ADD,
  URL_FORM_PROCESS,
  URL_FORM_PRODUCTION_UNIT,
  URL_FORM_TRANSFER_INVENTORY,
  URL_FORM_UTANG_PIUTANG,
  URL_FORM_WAREHOUSE,
  URL_FULFILMENT_REPORT,
  URL_FULFILMENT_REPORT_ID,
  URL_GEARS,
  URL_HOMEPAGE,
  URL_INVENTORI_INTELLIGENCE,
  URL_INVENTORY,
  URL_INVENTORY_MEMBERS,
  URL_KURSUS,
  URL_LEARNIING_REPORT,
  URL_LIST_TRANSACTIONS,
  URL_MAP_SCHEMA,
  URL_MASTER_ITEMS,
  URL_MUTATION_REPORT,
  URL_MUTATION_REPORT_ID,
  URL_NOTIF_INBOX,
  URL_ORDER_ADJUSTMENT,
  URL_PAYMENT_HISTORY,
  URL_PIUTANG,
  URL_PORTS,
  URL_PROCESS,
  URL_PROCESSING_REPORT,
  URL_PRODUCTION_UNIT,
  URL_PROJECT_DETAIL,
  URL_PROJECT_SUMMARY_DASHBOARD,
  URL_PROJECTS_ADD,
  URL_PROJECTS_EDIT,
  URL_PROJECTS_MENU,
  URL_REPORT_PNBP,
  URL_REPORT_PNBP_DETAIL,
  URL_SESSION_JOIN,
  URL_SESSION_LIST,
  URL_SESSION_PROCESS,
  URL_TNC_PRIVATE,
  URL_TRANSFER_INVENTORY,
  URL_TRANSFER_INVENTORY_DETAIL,
  URL_UTANG,
  URL_UTANG_APPROVAL,
  URL_VESSELS,
  URL_VESSELS_ADD,
  URL_VESSELS_DETAIL,
  URL_WAREHOUSE,
  URL_WHISTLE_BLOWINGS,
  URL_WORKPLACE,
  URL_QR_PRINTING,
  URL_SCANNER_SETTING,
  URL_PRINTER_SETTING,
  URL_AUTONUMBER_SETTING,
  URL_PRICE_TABLE,
  URL_TRANSACTION_QR_PRINT,
  URL_TRANSACTION_SUMMARY,
} from 'utils/pathUrl'
import {
  BUSINESS_AUTOREPO,
  BUSINESS_COMPANY,
  BUSINESS_MYAPPROVAL,
  BUSINESS_TALANGIN,
  BUSINESS_TOPUP,
  BUSINESS_TRANSACTION_PURCHASE,
  BUSINESS_TRANSACTION_SELL,
  BUSINESS_WITHDRAWAL,
  MANAGE,
  READ,
} from 'utils/subjectActions'
import { profileSetting } from './settingRoutes'
import DashboardTraceability from 'features/private-views/dashboard-traceability'
import DashboardTraceabilityDetail from 'features/private-views/dashboard-traceability/detail'

export const privateRouter = [
  {
    path: URL_HOMEPAGE,
    element: <Homepage />,
    action: READ,
    subject:
      BUSINESS_TALANGIN ||
      BUSINESS_TOPUP ||
      BUSINESS_TRANSACTION_PURCHASE ||
      BUSINESS_TRANSACTION_SELL ||
      BUSINESS_WITHDRAWAL,
    name: 'Beranda',
  },
  {
    path: '/',
    element: <Navigate to={URL_HOMEPAGE} replace />,
  },
  {
    path: URL_FINDORA_DASHBOARD,
    element: <ListFindoraDashboard />,
  },
  {
    path: '/findora-dashboard',
    element: <Navigate to={URL_FINDORA_DASHBOARD} replace />,
  },
  {
    path: URL_ANNUAL_CAPACITY,
    element: <AnnualCapacity />,
  },
  {
    path: URL_INVENTORI_INTELLIGENCE,
    element: <InventoriIntelligent />,
  },
  {
    path: URL_DETAIL_INVENTORI_INTELLIGENCE,
    element: <DetailInventoriIntelligent />,
  },
  {
    path: URL_PROJECT_SUMMARY_DASHBOARD,
    element: <ProjectDashboard />,
  },
  // {
  //   path: '/',
  //   element: <DashboardView />,
  //   action: READ,
  //   subject:
  //     BUSINESS_TALANGIN ||
  //     BUSINESS_TOPUP ||
  //     BUSINESS_TRANSACTION_PURCHASE ||
  //     BUSINESS_TRANSACTION_SELL ||
  //     BUSINESS_WITHDRAWAL,
  //   name: 'Dashboard',
  // },
  {
    element: <Transactions />,
    children: [
      {
        path: '/transaksi-pembelian-tambah-komoditas',
        element: <AddComodity />,
      },
      {
        path: '/transaksi-pembelian-pembayaran',
        element: <Payment />,
      },
      {
        path: '/transaksi-pembelian-pembayaran-uang-belanja-konfirmasi',
        element: <ConfirmPayment />,
      },
      {
        path: '/agency-view-payment',
        element: <AgencyViewPayment />,
      },
      {
        path: '/transaksi-pembelian-pembayaran-talangin',
        element: <TalanginConfirm />,
      },
    ],
  },
  {
    path: URL_DETAIL_TRANSACTION_ID,
    element: <DetailTransaction />,
    subject:
      BUSINESS_TALANGIN ||
      BUSINESS_TOPUP ||
      BUSINESS_TRANSACTION_PURCHASE ||
      BUSINESS_TRANSACTION_SELL ||
      BUSINESS_WITHDRAWAL,
  },
  {
    path: '/transaksi-pembelian-cash',
    element: <ConfirmCashPayment />,
  },
  {
    path: '/transaksi-pembelian-sukses',
    element: <SuccesTransaction />,
  },
  {
    path: '/purchase-commodity',
    element: <PurchaseCommodity />,
  },
  {
    path: '/sell-commodity',
    element: <SellCommodityView />,
  },
  {
    path: '/sell-commodity-success',
    element: <SuccessTrx />,
  },
  {
    path: '/topup',
    element: <TopupOnePayment />,
    // element: <Topup action={MANAGE} subject={BUSINESS_TOPUP} />,
  },
  // {
  //   path: '/topup-instruksi',
  //   element: <TransferBank action={READ} subject={BUSINESS_TOPUP} />,
  // },
  {
    path: '/tagihan-talangin',
    element: <TalanginInvoice action={READ} subject={BUSINESS_TALANGIN} />,
  },
  {
    path: URL_DETAIL_TAGIHAN_TALANGIN,
    element: (
      <DetailTalanginInvoice action={READ} subject={BUSINESS_TALANGIN} />
    ),
  },
  {
    path: '/penarikan-uang',
    element: <Withdraw action={READ} subject={BUSINESS_WITHDRAWAL} />,
  },
  {
    path: '/perpanjang-tempo-pembayaran',
    element: <Rollover action={MANAGE} subject={BUSINESS_TALANGIN} />,
  },
  {
    path: '/perpanjang-tempo-pembayaran-konfirmasi',
    element: <ConfirmRollover action={MANAGE} subject={BUSINESS_TALANGIN} />,
  },
  {
    path: URL_APPROVAL_BUY,
    element: <ApprovalPage />,
    action: READ,
    subject: BUSINESS_MYAPPROVAL,
    name: 'Approval',
    children: [
      {
        index: true,
        element: <ApprovalTable />,
      },
      {
        path: URL_APPROVAL_SELL,
        element: <TableRequestSell />,
      },
      {
        path: URL_APPROVAL_WITHDRAWAL,
        element: <TableRequestWithdrawal />,
      },
    ],
  },
  {
    path: URL_AGENT_APPROVAL,
    element: <ApprovalFarmers />,
  },
  {
    path: URL_FARMERS,
    element: <FarmersWeb />,
    children: [
      {
        index: true,
        element: <StaffList />,
      },
      {
        path: URL_FARMERS_REGIST,
        element: <FormRegis />,
      },
      {
        path: URL_FARMERS_DETAIL,
        element: <DetailFarmers />,
      },
      {
        path: URL_CHECK_FARMERS,
        element: <CheckFarmers />,
      },
      {
        path: URL_FARMERS_PENDING,
        element: <FarmersPendingList />,
      },
      {
        path: URL_FARMERS_GROUPS,
        element: <GroupsList />,
      },
      {
        path: URL_FARMERS_SHARED,
        element: <SharedFarmers />,
      },
      {
        path: URL_FARMERS_SUBGROUP,
        element: <FarmersTable />,
      },
    ],
  },
  {
    element: <SettingView />,
    children: profileSetting,
  },
  {
    element: <CommodityRepo />,
    action: MANAGE,
    subject: BUSINESS_AUTOREPO,
    name: 'Repo Barang',
    pathUrl: '/repo-komoditas/pengajuan',
    path: '/repo-komoditas',
    children: [
      {
        index: true,
        element: <SubmissionRepo />,
      },
      {
        path: 'list',
        element: <ListRepo />,
      },
    ],
  },
  {
    path: '/spatial',
    element: <Spatial />,
  },
  {
    path: URL_INVENTORY,
    element: <ManageStock />,
  },
  {
    path: URL_INVENTORY_MEMBERS,
    element: <InventoryMembers />,
  },
  {
    path: URL_DETAIL_INVENTORY,
    element: <DetailInventoriesPacking />,
  },
  {
    path: ARUS_KAS,
    element: <CashFlow />,
  },
  {
    path: HISTORY_ARUS_KAS,
    element: <HistoryCashFlow />,
  },
  {
    path: DETAIL_CASHFLOW,
    element: <DetailCashFlowById />,
  },
  {
    path: ARUS_KAS_FORM,
    element: <FormCashFlow />,
  },
  {
    path: URL_ARUS_KAS,
    element: <CashFlowNotes />,
  },
  {
    path: URL_UTANG,
    element: <IndexTabARAP />,
    action: READ,
    children: [
      {
        index: true,
        element: <PayableNotes />,
      },
      {
        path: URL_PIUTANG,
        element: <ReceivableNotes />,
      },
      {
        path: URL_PAYMENT_HISTORY,
        element: <PaymentHistory />,
      },
    ],
  },
  {
    path: URL_UTANG_APPROVAL,
    element: <ApprovalList />,
  },
  {
    path: URL_FORM_UTANG_PIUTANG,
    element: <FormPayableNotes />,
  },
  {
    path: URL_TNC_PRIVATE,
    element: <Tnc />,
  },
  {
    path: URL_VESSELS,
    element: <Vessels />,
    children: [
      {
        index: true,
        element: <VessselsTable />,
      },
      {
        path: URL_VESSELS_ADD,
        element: <FormAddVessel />,
      },
      {
        path: URL_VESSELS_DETAIL,
        element: <DetailVessels />,
      },
    ],
  },
  {
    path: URL_CATCHES,
    element: <Catches />,
    children: [
      {
        index: true,
        element: <CatchesTable />,
      },
      {
        path: URL_CATCHES_DETAIL,
        element: <DetailCatches />,
      },
    ],
  },
  {
    path: URL_WHISTLE_BLOWINGS,
    element: <WhistleBlowings />,
    children: [
      {
        index: true,
        element: <WhistleBlowingsTable />,
      },
    ],
  },
  {
    path: URL_GEARS,
    element: <Gears />,
    children: [
      {
        index: true,
        element: <GearsTable />,
      },
    ],
  },
  {
    path: URL_PORTS,
    element: <Ports />,
    children: [
      {
        index: true,
        element: <PortsTable />,
      },
    ],
  },
  {
    path: URL_COMPANIES,
    element: <Companies />,
    children: [
      {
        index: true,
        element: <CompaniesTable />,
      },
      {
        path: URL_COMPANIES_ADD,
        element: <FormAddCompanies />,
      },
    ],
  },
  {
    path: URL_FISHERIES,
    element: <Fisheries />,
    children: [
      {
        index: true,
        element: <FisheriesTable />,
      },
      {
        path: URL_FISHERIES_ADD,
        element: <FormAddFisheries />,
      },
    ],
  },
  {
    path: URL_AP2HI_LOG,
    element: <Logs />,
  },
  {
    path: URL_AP2HI_INSIGHT,
    element: <Insight />,
  },
  {
    path: URL_KURSUS,
    element: <Learning />,
  },
  {
    path: URL_WAREHOUSE,
    element: <Warehouse />,
  },
  {
    path: URL_FORM_WAREHOUSE,
    element: <FormWarehouse />,
  },
  {
    path: URL_TRANSFER_INVENTORY,
    element: <TransferInventory />,
  },
  {
    path: URL_TRANSFER_INVENTORY_DETAIL,
    element: <DetailTransferInventory />,
  },
  {
    path: URL_FORM_TRANSFER_INVENTORY,
    element: <FormTransferInventory />,
  },
  {
    path: URL_MUTATION_REPORT,
    element: <MutationReport />,
  },
  {
    path: URL_MUTATION_REPORT_ID,
    element: <DetailMutationReport />,
  },
  {
    path: URL_FULFILMENT_REPORT,
    element: <ReportFulfilment />,
  },
  {
    path: URL_FULFILMENT_REPORT_ID,
    element: <DetailReportFulfilment />,
  },
  {
    path: URL_PROCESSING_REPORT,
    element: <ReportProcess />,
  },
  {
    path: URL_DETAIL_PROCESS,
    element: <DetailProcess />,
  },
  {
    path: URL_DETAIL_WAREHOUSE,
    element: <DetailWarehouse />,
  },
  {
    path: URL_BALANCE,
    element: <Budget />,
  },
  {
    path: URL_LEARNIING_REPORT,
    element: <LearningReport />,
  },
  {
    path: URL_ADDRESS_BOOK,
    element: <ListAddressBook />,
  },
  {
    path: URL_CONFIRM_PIN_TALANGIN,
    element: <PinConfirm />,
  },
  {
    path: URL_CONFIRM_PIN_TRANSAKSI,
    element: <CheckPinTrx />,
  },
  {
    path: URL_ORDER_ADJUSTMENT,
    element: <OrderAdjustment />,
  },
  {
    path: URL_TRANSACTION_QR_PRINT,
    element: <TransactionQRPrint />,
  },
  {
    path: '/pengaturan-password',
    element: <PasswordSetting />,
  },
  {
    path: '/pengaturan-pin',
    element: <PinSetting />,
  },
  {
    path: '/pengaturan-perusahaan',
    element: <CompanySetting action={MANAGE} subject={BUSINESS_COMPANY} />,
  },
  {
    path: '/pengaturan-tim',
    element: <TeamSetting action={MANAGE} subject={BUSINESS_COMPANY} />,
  },
  {
    path: URL_SCANNER_SETTING,
    element: <SettingView />,
    children: [
      {
        index: true,
        element: <ScannerSetting />,
      },
    ],
  },
  {
    path: URL_PRINTER_SETTING,
    element: <SettingView />,
    children: [
      {
        index: true,
        element: <PrinterSetting />,
      },
    ],
  },
  {
    path: URL_AUTONUMBER_SETTING,
    element: <SettingView />,
    children: [
      {
        index: true,
        element: <AutoNumberSetting />,
      },
    ],
  },
  {
    path: URL_PRICE_TABLE,
    element: <PriceTable />,
  },
  {
    path: URL_CONFIGURATIONS,
    element: <Configurations />,
    children: [
      {
        index: true,
        element: <ListConfigurations />,
      },
    ],
  },
  {
    path: URL_REPORT_PNBP,
    element: <ReportPnbp />,
    children: [
      {
        index: true,
        element: <ListReportPnbp />,
      },
    ],
  },
  {
    path: URL_QR_PRINTING,
    element: <SettingView />,
    children: [
      {
        index: true,
        element: <QRPrinting />,
      },
    ],
  },
  {
    path: URL_REPORT_PNBP_DETAIL,
    element: <DetailReportPnbp />,
  },
  {
    path: URL_WORKPLACE,
    element: <ListWorkplace />,
  },
  {
    path: URL_CONFIGURATIONS_ADD,
    element: <AddConfiguration />,
  },
  {
    path: URL_ATTENDANCE_REPORT,
    element: <AttendanceSummary />,
  },
  {
    path: URL_ATTENDANCE_TODAY,
    element: <TodayReport />,
  },
  {
    path: URL_ATTENDANCE_INDIVIDUAL,
    element: <IndividualReport />,
  },
  {
    path: URL_ATTENDANCE,
    element: <Attendance />,
  },
  {
    path: URL_CENTER_ATTENDANCE,
    element: <CenterAttendance />,
  },
  {
    path: URL_NOTIF_INBOX,
    element: <NotifInboxTable />,
  },
  {
    path: URL_ATTENDANCE_REPORT_MEMBER,
    element: <AttendanceIndividualManagement />,
  },
  {
    path: URL_LIST_TRANSACTIONS,
    element: <ListTransactions />,
  },
  {
    path: URL_TRANSACTION_SUMMARY,
    element: <TransactionSummary />,
  },
  {
    path: URL_DETAIL_PIUTANG,
    element: <DetailReceivable />,
  },
  {
    path: URL_DETAIL_UTANG,
    element: <DetailPayable />,
  },
  {
    path: URL_FINDORA_SYNC_DATA,
    element: <SyncDataList />,
  },
  {
    path: URL_FINDORA_PRODUCT_MAPPING,
    element: <ListProductMapping />,
  },
  {
    path: URL_FINDORA_PRODUCT_MAPPING_SCHEMA,
    element: <ListProductMappingSchema />,
  },
  {
    path: URL_FINDORA_LOGS,
    element: <ListFindoraLogs />,
  },
  {
    path: URL_PRODUCTION_UNIT,
    element: <ProductionUnit />,
  },
  {
    path: URL_DETAIL_PRODUCTION_UNIT,
    element: <DetailProductionUnit />,
  },
  {
    path: URL_FORM_PRODUCTION_UNIT,
    element: <FormProductionUnit />,
  },
  {
    path: URL_EVENT_PARTNER,
    element: <ListEventReport />,
  },
  {
    path: URL_EVENT_PARTNER_FORM,
    element: <FormEventPartner />,
  },
  {
    path: URL_EVENT,
    element: <ListEvent />,
  },
  {
    path: URL_EVENT_FORM,
    element: <FormEvent />,
  },
  {
    path: URL_EVENT_PARTICIPANT,
    element: <ListEventParticipant />,
  },
  {
    path: URL_EVENT_PARTICIPANT_FORM,
    element: <FormEventParticipant />,
  },
  {
    path: URL_PROJECTS_MENU,
    element: <ListProjectsMenu />,
  },
  {
    path: URL_PROJECTS_ADD,
    element: <FormAddEditProject />,
  },
  {
    path: URL_PROJECTS_EDIT,
    element: <FormAddEditProject />,
  },
  {
    path: URL_EMPLOYEE_PAYMENTS,
    element: <ListEmployeePayments />,
  },
  {
    path: URL_WAGE_SALARY,
    element: <WageSalary />,
  },
  {
    path: URL_WAGE_SALARY_CREATE,
    element: <WageSalaryCreate />,
  },
  {
    path: URL_WAGE_SALARY_DETAIL,
    element: <WageSalaryDetail />,
  },
  {
    path: URL_EMPLOYEE_PAYMENTS_SUMMARY,
    element: <PaymentSummary />,
  },
  {
    path: URL_EMPLOYEE_PAYMENTS_AUTO_CALCULATION,
    element: <AutoCalculation />,
  },
  {
    path: URL_MASTER_ITEMS,
    element: <ListMasterItems />,
  },
  {
    path: URL_MAP_SCHEMA,
    element: <ListMapSchema />,
  },
  {
    path: URL_FINDORA_ITEMS,
    element: <FindoraItems />,
  },
  {
    path: URL_EVENT_APPROVAL,
    element: <ListEventApproval />,
  },
  // {
  //   path: URL_EVENT_TIMELINE,
  //   element: <ListEvent />,
  // },
  {
    path: URL_EVENT_CERTIFICATE,
    element: <EventCertificateList />,
  },
  {
    path: URL_EVENT_CERTIFICATE_DETAIL,
    element: <EventCertificateDetail />,
  },
  {
    path: URL_SESSION_JOIN,
    element: <JoinSession />,
  },
  {
    path: URL_SESSION_PROCESS,
    element: <Session />,
  },
  {
    element: <IndexProcess />,
    children: [
      {
        path: URL_PROCESS,
        element: <ListProcess />,
      },
      {
        path: URL_FORM_PROCESS,
        element: <ProcessPage />,
      },
      {
        path: URL_SESSION_LIST,
        element: <QRList />,
      },
    ],
  },
  {
    path: URL_PROJECT_DETAIL,
    element: <DetailProject />,
  },
  {
    path: URL_DASHBOARD_TRACEABILITY,
    element: <DashboardTraceability />,
  },
  {
    path: URL_DASHBOARD_TRACEABILITY_DETAIL,
    element: <DashboardTraceabilityDetail />,
  },
]
